import O2oEnrollProjectsetAudit from './src/main';

/* istanbul ignore next */
O2oEnrollProjectsetAudit.install = function(Vue) {
  Vue.component(O2oEnrollProjectsetAudit.name, O2oEnrollProjectsetAudit);
};

export default O2oEnrollProjectsetAudit;
